import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { navigate } from "../lib/router";
import { COPY } from "../content/copy";

// JWT payloads are base64url-encoded (uses "-"/"_", no padding), which
// `atob` cannot decode directly. Normalize to standard base64 before
// decoding. Decode is for client-side render gating only - RLS is the
// server-side enforcement of the is_admin claim.
function decodeJwtPayload(token: string | null | undefined): { is_admin?: boolean; email?: string } | null {
  if (!token) return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;
  try {
    let b64 = (parts[1] ?? "").replace(/-/g, "+").replace(/_/g, "/");
    const pad = b64.length % 4;
    if (pad) b64 += "=".repeat(4 - pad);
    return JSON.parse(atob(b64)) as { is_admin?: boolean; email?: string };
  } catch {
    return null;
  }
}

export function AdminRoute() {
  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      const { data } = await supabase().auth.getSession();
      const session = data.session;
      if (!session) {
        navigate("/admin/login", true);
        return;
      }
      const claims = decodeJwtPayload(session.access_token);
      if (!claims?.is_admin) {
        navigate("/admin/login", true);
        return;
      }
      setEmail(session.user.email ?? "");
    })();
  }, []);

  if (email === null) return null;
  return (
    <main className="landing">
      <div className="landing__form">
        <p className="landing__heading">{COPY.admin.stub.text.replace("{email}", email)}</p>
        <button
          className="landing__submit"
          onClick={async () => {
            await supabase().auth.signOut();
            navigate("/admin/login");
          }}
        >
          sign out
        </button>
      </div>
    </main>
  );
}
